module.exports = __webpack_public_path__ + "static/media/angular.b90a7111.svg";